import styled from 'styled-components';

import { basicSmallTextStyle, Text } from '@dreryk/react-components';

export const StyledPreInterviewApprovalDateText = styled(Text)`
   ${basicSmallTextStyle}
   display: flex;
   justify-content: flex-end;
   color: ${(props) => props.theme.placeholder};
`;
StyledPreInterviewApprovalDateText.displayName = 'StyledPreInterviewApprovalDateText';
